import { useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import cn from 'classnames';

import { DemoButton, SplitText, useReveal } from 'components';
import { CONTACT_EMAIL } from 'src/constants/misc';

import { usePage } from '../../pages';

import style from './Faq.module.scss';

const Faq = () => {
  const { t } = useTranslation('page');
  const { id } = usePage();
  const sectionRef = useRef(null);
  const [open, setOpen] = useState([0]);
  const items = t(`${id}.faq.items`, { returnObjects: true });

  useReveal(sectionRef);

  const toggle = (i) => setOpen((list) => (list.includes(i) ? list.filter((j) => j !== i) : [...list, i]));

  return (
    <section
      id='faq'
      ref={sectionRef}
      className='sec tone-light'
      data-tone='light'
    >
      <div className={cn('wrap', style.grid)}>
        <div className={style.side}>
          <p className='mono-label'>{t(`${id}.faq.label`)}</p>
          <SplitText
            as='h2'
            className='h2'
            reveal
          >
            {t(`${id}.faq.title`)}
          </SplitText>
          <p className={style.intro}>{t(`${id}.faq.intro`)}</p>
          <div className={style.contact}>
            <p className={style.contactTitle}>{t(`${id}.faq.contactTitle`)}</p>
            {t(`${id}.faq.contactText`) && <p className={style.contactText}>{t(`${id}.faq.contactText`)}</p>}
            <p className={style.mail}>
              <a
                className='sel'
                href={`mailto:${CONTACT_EMAIL}`}
              >
                {CONTACT_EMAIL}
              </a>
            </p>
            <DemoButton>{t(`${id}.cta`)}</DemoButton>
          </div>
        </div>
        <div className={style.list}>
          {items.map((item, i) => {
            const isOpen = open.includes(i);
            return (
              <div
                key={i}
                className={cn(style.item, isOpen && style.open)}
                data-reveal
              >
                <button
                  className={style.question}
                  type='button'
                  aria-expanded={isOpen}
                  onClick={() => toggle(i)}
                >
                  {item.q}
                  <span
                    className={style.pm}
                    aria-hidden='true'
                  />
                </button>
                <div className={style.answer}>
                  <div>
                    <p>
                      <Trans
                        t={t}
                        i18nKey={`${id}.faq.items.${i}.a`}
                        components={{ todo: <span className='todo' /> }}
                      />
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
